import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AiChatbotSupportLayer from "./AiChatbotSupportLayer";

const AiChatbotSupportPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="AI Chatbot Support" />
        <AiChatbotSupportLayer />
      </MasterLayout>
    </>
  );
};

export default AiChatbotSupportPage;
